import { IconProps } from 'components/icons/types';

export const Tiktok = (props: IconProps) => {
  const { width = 18, height = 18, className } = props;

  return (
    <svg className={className} width={width} height={height} viewBox="0 0 18 18" fill="none"
         xmlns="http://www.w3.org/2000/svg">
      <path
        d="M12.8044 0H9.77086V12.2608C9.77086 13.7218 8.60414 14.9218 7.1522 14.9218C5.70025 14.9218 4.53352 13.7218 4.53352 12.2608C4.53352 10.8261 5.67433 9.65215 7.07443 9.6V6.52175C3.98904 6.5739 1.5 9.10435 1.5 12.2608C1.5 15.4435 4.04089 18 7.17814 18C10.3153 18 12.8562 15.4174 12.8562 12.2608V5.9739C13.997 6.8087 15.3971 7.30435 16.875 7.33045V4.25217C14.5934 4.17391 12.8044 2.29565 12.8044 0Z"
        fill="currentColor" />
    </svg>
  )
};
